import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Layout } from "components/ui/Layout";
import RootRoutes from "./routes/RootRoutes";

export default function AuthenticatedApp() {
  const location = useLocation();

  useEffect(() => {
    reauthenticateIfNotLoggedIn();
  }, [location]);

  return (
    <Layout>
      <RootRoutes />
    </Layout>
  );
}

async function reauthenticateIfNotLoggedIn() {
  const res = await fetch("/api/my/am_i_logged_in");
  const { amILoggedIn = false } = await res.json();

  if (!amILoggedIn) {
    window.location = "/auth/cas";
  }
}
